
import { defineComponent } from "vue";
import SandpackCmp from "./sandpack/SandpackCmp.vue";
import { reactTabsMap, vueTabsMap } from "../config/tabs";

const needRendertabs: Array<any> = reactTabsMap;
export default defineComponent({
  name: "Example",
  props: {},
  data() {
    return {
      tabIndex: "0",
      tabName: "modelRender",
      tabPosition: "left",
      radio: "0",
      needRendertabs,
      unScroll: false,
      t1: 0,
      t2: 0,
      timer: 0,
      frame: "react",
    };
  },
  components: {
    SandpackCmp,
  },
  watch: {
    radio(newRadio) {
      if (newRadio === "0") {
        this.needRendertabs = reactTabsMap;
        this.frame = "react";
      } else {
        this.needRendertabs = vueTabsMap;
        this.frame = "vue3";
      }
    },
  },
  methods: {
    onClick(tab: any) {
      this.unScroll = true; // 点击tab的时候禁止执行tab-name赋值动作
      const target: any = document.querySelector(".scroll-content");
      const scrollItems: any = document.querySelectorAll(".scroll-item");
      // 判断滚动条是否滚动到底部
      if (target.scrollHeight <= target.scrollTop + target.clientHeight) {
        this.tabIndex = tab.index.toString();
      }
      const totalY =
        scrollItems[tab.index].offsetTop - scrollItems[0].offsetTop; // 锚点元素距离其offsetParent(这里是body)顶部的距离(待滚动的距离)
      let distance: any = document.querySelector(".scroll-content")?.scrollTop; // 滚动条距离滚动区域顶部的距离
      // let distance = document.body.scrollTop || document.documentElement.scrollTop || window.pageYOffset // 滚动条距离滚动区域顶部的距离(滚动区域为窗口)
      // 滚动动画实现, 使用setTimeout的递归实现平滑滚动，将距离细分为50小段，10ms滚动一次
      // 计算每一小段的距离
      let step = totalY / 50;
      if (totalY > distance) {
        smoothDown(document.querySelector(".scroll-content"));
      } else {
        const newTotal = distance - totalY;
        step = newTotal / 50;
        smoothUp(document.querySelector(".scroll-content"));
      }
      // 参数element为滚动区域
      function smoothDown(element: any) {
        if (distance < totalY) {
          distance += step;
          element.scrollTop = distance;
          // requestAnimationFrame(() => {
          smoothDown(element);
          // });
        } else {
          element.scrollTop = totalY;
        }
      }

      // 参数element为滚动区域
      function smoothUp(element: any) {
        if (distance > totalY) {
          distance -= step;
          element.scrollTop = distance;
          // requestAnimationFrame(() => {
          smoothUp(element);
          // });
        } else {
          element.scrollTop = totalY;
        }
      }
    },
    isScrollEnd() {
      this.t2 = document.querySelector(".scroll-content")?.scrollTop || 0;
      if (this.t2 == this.t1) {
        this.unScroll = false;
      }
    },

    // 滚动条滚动
    onScroll(e: any) {
      // 滚动结束之后执行tab-name赋值动作
      clearTimeout(this.timer);
      this.t1 = e.target.scrollTop;
      this.timer = setTimeout(this.isScrollEnd, 100) as any;
      if (this.unScroll) return;
      const scrollItems: any = document.querySelectorAll(".scroll-item");
      for (let i = scrollItems.length - 1; i >= 0; i--) {
        // 判断滚动条滚动距离是否大于当前滚动项可滚动距离
        const judge =
          e.target.scrollTop >=
          scrollItems[i].offsetTop - scrollItems[0].offsetTop - 400;
        if (judge) {
          this.tabIndex = i.toString();
          // 找对应的tab-name值
          this.tabName = this.needRendertabs[Number(this.tabIndex)].refName;
          break;
        }
      }
    },
  },
});
